const setCatType4 = (payload) => {
  return {
    type: "catType4",
    payload,
  };
};

export default setCatType4;
